export enum LOCATION_TYPE_LIST {
  CITY = 'city',
  ZONE = 'zone',
  NEIGHBORHOOD = 'neighborhood',
  RESIDENTIAL_COMPLEX = 'residential_complex'
}
